import { useState } from 'react';
import {
  Alert,
  Box,
  FormControlLabel,
  Paper,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import DarkModeRounded from '@mui/icons-material/DarkModeRounded';
import LightModeRounded from '@mui/icons-material/LightModeRounded';
import {
  getStoredThemeMode,
  PORTAL_THEME_MODE_STORAGE_KEY,
} from '../components/theme/theme';

const Configuracoes = () => {
  const [themeMode, setThemeMode] = useState(getStoredThemeMode);
  const isDarkMode = themeMode === 'dark';

  const handleThemeModeChange = (event) => {
    const nextMode = event.target.checked ? 'dark' : 'light';
    setThemeMode(nextMode);
    localStorage.setItem(PORTAL_THEME_MODE_STORAGE_KEY, nextMode);

    window.setTimeout(() => {
      window.location.reload();
    }, 160);
  };

  return (
    <Stack spacing={3}>
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
          Configurações
        </Typography>
        <Typography color="text.secondary">
          Personalize sua experiência no Portal do Cliente.
        </Typography>
      </Box>

      <Paper
        elevation={0}
        sx={(theme) => ({
          p: { xs: 2, md: 3 },
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: 'background.paper',
        })}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            {isDarkMode ? <DarkModeRounded color="primary" /> : <LightModeRounded color="primary" />}
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Modo escuro
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Alterna cores de fundo, textos e componentes principais do portal.
              </Typography>
            </Box>
          </Stack>

          <FormControlLabel
            control={<Switch checked={isDarkMode} onChange={handleThemeModeChange} />}
            label={isDarkMode ? 'Ativado' : 'Desativado'}
            sx={{ m: 0 }}
          />
        </Stack>
      </Paper>

      <Alert severity="info">
        A alteração é salva neste navegador e aplicada ao portal após recarregar a interface.
      </Alert>
    </Stack>
  );
};

export default Configuracoes;
